import { Header } from "../../header/Header";
import { Footer } from "../footer/Footer";
import { Joinus } from "../joinus/Joinus";
import { ServicesShowcase } from "../service/ServicesShowcase";
import a3 from "../../assets/a3.jpg";
import '../aboutus/About.css';

export const Individual = () => {
    return (
        <div>
            <Header />
            <div className="about-us">
            <div className="about-header">
              <h1>Individual Therapy</h1>
            </div>
            <div className="about-section">
                <img src={a3} alt="Mission" className="about-image" />
                <div className="about-text">
                  <p>
                    The struggle to manage behaviour and lifestyle along with overthinking thoughts and work life balance is pretty common. Individual therapy is centred around the needs and concerns of a single individual it provides a safe and confidential space for individuals to explore and address their personal issues, emotions and mental health concerns.
                    The primary goal is to help the individual gain inside into their thoughts feelings and behaviour.
                    The individual therapy also helps to develop I am stills to manage and overcome challenges. 
                  </p>
                </div>
            </div>
            </div>
            <ServicesShowcase />
            <Joinus />
            <Footer />
        </div>
    );
};